import { ScrollTrigger } from "gsap/ScrollTrigger";

document.querySelectorAll('.river-of-photos').forEach(el => {
  // el.parentElement.style.height = `${el.offsetHeight * (window.innerWidth < 750 ? 2.2 : 1.65)}px`;
  const figures = el.querySelectorAll("figure");
  figures.forEach((figure) => {
    figure.insertAdjacentHTML("afterend", "<div></div>");
  });
  const images = el.querySelectorAll("img");
  images.forEach((image) => {
    image.dataset.scale = Math.random() * 0.75 + 1; // 1 to 1.75
    image.dataset.speed = Math.random() * 2 + 0.5;
    image.decoding = "sync";
    image.loading = "eager";
  });

  // https://stackoverflow.com/a/5598797
  const getOffsetTop = (elem) => {
    var offsetTop = 0;
    do {
      if (!isNaN(elem.offsetTop)) {
        offsetTop += elem.offsetTop;
      }
    } while ((elem = elem.offsetParent));
    return offsetTop;
  };

  const scrollHandler = () => {
    const scroll = getOffsetTop(el) - window.pageYOffset;
    images.forEach((image) => {
      const speed = image.dataset.speed;
      const y = scroll * speed;
      image.style.transform = `translateY(${y}px) scale(${image.dataset.scale})`;
    });
  };
  // const resizeHandler = () => {
  // 	el.parentElement.style.height = `${(el.offsetHeight * (window.innerWidth < 750 ? 2.2 : 1.6))/2}px`;
  // };
  // setTimeout(() => {
  // 	requestAnimationFrame(resizeHandler)
  // }, 1000);
  // ScrollTrigger.addEventListener("refresh", () =>
  // 	requestAnimationFrame(resizeHandler)
  // );

  window.addEventListener("scroll", () => requestAnimationFrame(scrollHandler));
  // window.addEventListener('resize', () => requestAnimationFrame(resizeHandler));
});
